import * as yup from "yup";

import { useForm, useFormState } from "react-hook-form";

import Validations from "@helpers/validations";
import dayjs from "dayjs";
import { object } from "yup";
import size from "lodash/size";
import useAxios from "@hooks/use-axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const defaultValues = {
    name       : "",
    description: "",
    assignedTo : "",
    status     : "",
    dueDate    : new Date()
};

const useUpsert = props => {
    const {
        handleModalConfig,
        getTasks,
        modalConfig: { row },
        isEdit
    } = props;

    const { platformId } = useParams();
    const { loading, axiosInstance } = useAxios({
        base: "panel"
    });
    const { clientId } = useParams();

    const { requiredValidation, emptyObjValidation } = Validations();

    const validationSchema = object().shape({
        name       : requiredValidation({ name: "Name" }),
        status     : requiredValidation({ name: "Status" }),
        dueDate    : yup.date().required({ name: "Due Date" }),
        assignedTo : emptyObjValidation({ name: "Assigned To" }),
        description: requiredValidation({ name: "Description" })
    });

    const methods = useForm({
        defaultValues,
        resolver: yupResolver(validationSchema)
    });

    const { control, handleSubmit, reset } = methods;
    const { isDirty } = useFormState({ control });

    useEffect(() => {
        if (isEdit && size(row)) {
            reset({
                name       : row.name,
                description: row.description,
                status     : row.status,
                assignedTo : {
                    value: row.assignedTo.id,
                    label: row.assignedTo.name
                },
                dueDate: row.dueDate ? dayjs(row.dueDate).toDate() : new Date()
                
            });
        } else {
            reset(defaultValues);
        }
    }, [isEdit, row]);

    const onSubmit = () => {
        handleSubmit(async data => {
            const payload = {
                name       : data.name,
                description: data.description,
                ...(!isEdit && { assignedTo: data.assignedTo?.value }),
                status     : data.status,
                dueDate    : dayjs(data.dueDate).format("YYYY-MM-DD")
            };

            if (row.id) {
                await axiosInstance.patch(`/tasks/${platformId}/${row.id}`, payload);
            } else {
                await axiosInstance.post(`/tasks/${platformId}`, {
                    ...payload,
                    clientId
                });
            }

            handleModalConfig();
            getTasks({ page: 1, limit: 10 });
        })();
    };

    return {
        onSubmit,
        methods,
        updateLoading: loading,
        isDirty
    };
};

export default useUpsert;
